import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { StorageValue } from 'zustand/middleware';

import type { AuthState, UserAuthenticationResponse } from '@features/auth/types';

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      isLoggedIn: false,
      user: null,

      signIn: (userData: UserAuthenticationResponse) => {
        console.log('AuthStore signIn 호출:', userData);
        set({
          isLoggedIn: true,
          user: userData,
        });
        console.log('AuthStore 상태 업데이트 완료');
      },

      signOut: () => {
        set({
          isLoggedIn: false,
          user: null,
        });
      },
    }),
    {
      name: 'auth-storage',
      storage: {
        getItem: (name: string) => {
          const item = localStorage.getItem(name);
          return item ? JSON.parse(item) : null;
        },
        setItem: (name: string, value: StorageValue<AuthState>) => {
          localStorage.setItem(name, JSON.stringify(value));
        },
        removeItem: (name: string) => {
          localStorage.removeItem(name);
        },
      },
    },
  ),
);
